import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import AdminDashboard from "../pages/Admin/AdminDashboard";
import UserManagement from "../pages/Admin/UserManagement";
import FeedbackReports from "../pages/FeedbackReports";
import ViewFeedback from "../pages/ViewFeedback";
import NotFound from "../pages/NotFound";
import { HourglassEmpty as ComingSoonIcon, Build as UnderConstructionIcon } from "@mui/icons-material";

const AdminRoutes = () => (
  <Routes>
    {/* Main Admin Layout */}
    <Route element={<Layout title="Admin Dashboard" linkToNavigate="/admin" />}>
      <Route path="/" element={<AdminDashboard />} />
      <Route path="/users" element={<UserManagement />} />
      <Route path="/reports" element={<FeedbackReports />} />
      <Route path="/feedbacks" element={<ViewFeedback />} />

      {/* Coming Soon Page */}
      <Route
        path="/coming-soon"
        element={
          <NotFound
            message="Coming Soon"
            secondaryMessage="We're working hard to bring this feature to you soon."
            redirectPath="/admin"
            buttonText="Back to Dashboard"
            icon={
              <ComingSoonIcon
                sx={{
                  fontSize: "80px",
                  color: "#ff9800", // Orange color for "Coming Soon"
                  marginBottom: "20px",
                }}
              />
            }
          />
        }
      />

      {/* Under Development Page */}
      <Route
        path="/under-development"
        element={
          <NotFound
            message="Under Development"
            secondaryMessage="This feature is currently under development. Please check back later."
            redirectPath="/admin"
            buttonText="Back to Dashboard"
            icon={
              <UnderConstructionIcon
                sx={{
                  fontSize: "80px",
                  color: "#4caf50", // Green color for "Under Development"
                  marginBottom: "20px",
                }}
              />
            }
          />
        }
      />
    </Route>

    {/* Fallback 404 Route */}
    <Route
      path="*"
      element={
        <NotFound
          redirectPath="/admin"
          message="404: Admin Page Not Found"
          secondaryMessage="The page you're looking for does not exist or has been moved."
          buttonText="Back to Dashboard"
        />
      }
    />
  </Routes>
);

export default AdminRoutes;
